const stripHtml = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
};

const typeMap = {
  logo: "Logotipo de la marca",
  logotipo: "Logotipo de la marca",
  brand: "Logotipo de la marca",
  brandmark: "Logotipo de la marca",
  icon: "Icono del elemento",
  icono: "Icono del elemento",
  banner: "Cabecera del contenido",
  hero: "Cabecera del contenido",
  slide: "Cabecera del contenido",
  slider: "Cabecera del contenido",
  avatar: "Avatar del perfil",
  profile: "Avatar del perfil",
  galeria: "Elemento de galeria",
  gallery: "Elemento de galeria",
  producto: "Producto",
  product: "Producto",
  servicio: "Servicio",
  service: "Servicio",
};

const describeTypeOrId = ({ type, id }) => {
  const cleanType = stripHtml(type).toLowerCase();
  const base = typeMap[cleanType] || (cleanType ? `Elemento visual de tipo ${cleanType}` : "Elemento visual");
  if (id === null || id === undefined || String(id).trim() === "") {
    return base;
  }
  return `${base} con identificador ${stripHtml(id)}`;
};

const applyPrefix = (text, options = {}) => {
  const prefix = options.prefix || "Imagen representativa de {text}";
  if (typeof prefix === "function") return prefix(text);
  if (typeof prefix === "string") {
    if (prefix.includes("{text}")) return prefix.replace("{text}", text);
    return `${prefix} ${text}`;
  }
  return `Imagen representativa de ${text}`;
};

const buildAltText = (fields = {}, options = {}) => {
  const ordered = ["alt", "name", "title", "label", "text"];

  for (const key of ordered) {
    if (fields && Object.prototype.hasOwnProperty.call(fields, key)) {
      const cleaned = stripHtml(fields[key]);
      if (cleaned) return applyPrefix(cleaned, options);
    }
  }

  const type = fields ? fields.type : "";
  const id = fields ? fields.id : "";
  if (stripHtml(type) || stripHtml(id)) {
    return describeTypeOrId({ type, id });
  }

  return options.fallback || "Elemento visual";
};

export { stripHtml, buildAltText };
